import { render, staticRenderFns } from "./text.vue?vue&type=template&id=2cb71092&scoped=true&"
import script from "./text.vue?vue&type=script&lang=js&"
export * from "./text.vue?vue&type=script&lang=js&"
import style0 from "./text.vue?vue&type=style&index=0&id=2cb71092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb71092",
  null
  
)

export default component.exports